import { render, staticRenderFns } from "./ProjectRequestsListCustom.vue?vue&type=template&id=03faff41&scoped=true&"
import script from "./ProjectRequestsListCustom.vue?vue&type=script&lang=js&"
export * from "./ProjectRequestsListCustom.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRequestsListCustom.vue?vue&type=style&index=0&id=03faff41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03faff41",
  null
  
)

export default component.exports